import React, { useEffect, useState } from "react";
import Navbar from "./Navbar/Navbar.jsx";
import axios from "axios";
import baseURL from "./config.js";

const AgentDetails = () => {
  const [agentData, setAgentData] = useState([]);
  const [crewDetails, setCrewDetails] = useState([]);
  const [groupedData, setGroupedData] = useState([]);

  useEffect(() => {
    const fetchDetails = async () => {
      try {
        const vesselResponse = await axios.get(`${baseURL}/api/vesselformbyagent`);
        const crewResponse = await axios.get(`${baseURL}/api/CrewfromAgent`);

        const vessels = vesselResponse.data;
        const crews = crewResponse.data;

        // Group data by selectedAgent ID
        const grouped = vessels.reduce((acc, vessel) => {
          const agentId = vessel.selectedAgent?._id;
          if (agentId) {
            if (!acc[agentId]) {
              acc[agentId] = {
                agent: vessel.selectedAgent,
                vessels: [],
                crews: []
              };
            }
            acc[agentId].vessels.push(vessel);
          }
          return acc;
        }, {});

        crews.forEach(crew => {
          const agentId = crew.selectedAgent?._id;
          if (agentId && grouped[agentId]) {
            grouped[agentId].crews.push(crew);
          }
        });

        setGroupedData(Object.values(grouped)); // Convert object to array
      } catch (error) {
        console.error("Error fetching details:", error);
      }
    };

    fetchDetails();
  }, []);

  return (
    <>
      <Navbar />
      <div className="AgentDetailsTable">
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              <th style={{ border: "1px solid #ddd", padding: "8px", textAlign: "left" }}>
                Crewing Agent
              </th>
              <th style={{ border: "1px solid #ddd", padding: "8px", textAlign: "left" }}>
                Vessels
              </th>
              <th style={{ border: "1px solid #ddd", padding: "8px", textAlign: "left" }}>
                Crews
              </th>
            </tr>
          </thead>
          <tbody>
            {groupedData.map((group, index) => (
              <tr key={index}>
                <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                  <div><strong>Name:</strong> {group.agent?.agentName}</div>
                  <div><strong>Email:</strong> {group.agent?.email}</div>
                  <div><strong>Contact:</strong> {group.agent?.contactNumber}</div>
                </td>
                <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                  {group.vessels.map(vessel => (
                    <div key={vessel._id}>
                      <div><strong>Vessel Name:</strong> {vessel.vesselname}</div>
                      <div><strong>Type:</strong> {vessel.vesseltype}</div>
                      <div><strong>Category:</strong> {vessel.vessel_category}</div>
                      {index < group.vessels.length - 1 && <hr style={{ margin: "8px 0", border: "1px solid #ddd" }} />}
                    </div>
                    
                  ))}
                </td>
                <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                  {group.crews.map(crew => (
                    <div key={crew._id}>
                      <div><strong>Name:</strong> {crew.name}</div>
                      <div><strong>Indos No:</strong> {crew.indosno}</div>
                      <div><strong>Email:</strong> {crew.email}</div>
                    </div>
                  ))}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default AgentDetails;
